import { NgModule } from '@angular/core';
import { ElectronService } from './src/electronService';
import { ElectronServiceRef } from './src/electronServiceRef';
export * from './src/electronService';
export * from './src/electronServiceRef';
var NgxElectronModule = (function () {
    function NgxElectronModule() {
    }
    return NgxElectronModule;
}());
export { NgxElectronModule };
NgxElectronModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                exports: [],
                providers: [{ provide: ElectronService, useClass: ElectronServiceRef }]
            },] },
];
/** @nocollapse */
NgxElectronModule.ctorParameters = function () { return []; };



//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/ngx-electron/index.js
// module id = ../../../../ngx-electron/index.js
// module chunks = 37